import * as React from 'react'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import useOwnUser from '../../../../../../hooks/useOwnUser'
import { useUpdateVacationMutation } from '../../../../../../features/vacations/vacationsApiSlice'
import { IApprovalRejectionProps } from '../../../../../../pkg/UI'
import {
  Backdrop,
  DialogContainer,
  DialogForm,
  DialogHeader,
  DialogContent,
  InfoContainer,
  ButtonGroup,
  AcceptButton,
  CancelButton,
} from './approvalElements'

const ApprovalDialog = ({ ...props }: IApprovalRejectionProps): JSX.Element => {
  const { t } = useTranslation()
  const user = useOwnUser()
  const [updateRequest] = useUpdateVacationMutation()
  const [isSubmitting, setIsSubmitting] = React.useState(false)

  const handleSubmit = (
    e: React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLButtonElement>,
  ): void => {
    e.preventDefault()
    setIsSubmitting(true)

    const data = { ...props.request }
    data.status = 'approved'
    data.decision_maker_id = user.userUID as number
    data.decision_date = dayjs(new Date()).toISOString()

    updateRequest(data)
      .then((res: any) => {
        console.log(res)
        props.refetch()
        props.handleClose()
      })
      .catch((error: any) => {
        if (error.status === 500) {
          alert(t('CompanyHistory:Approval.serverError'))
        } else {
          console.error(error)
        }
      })
      .finally(() => {
        setIsSubmitting(false)
      })
  }

  if (!props.isOpen) return <></>

  const hasAdditionalInfo =
    props.request.additional_info && props.request.additional_info.trim() !== ''

  return (
    <Backdrop>
      <DialogContainer>
        <DialogForm onSubmit={handleSubmit}>
          <DialogHeader>
            <h2>{t('CompanyHistory:Approval.acceptVacation')}</h2>
          </DialogHeader>

          <DialogContent>
            {hasAdditionalInfo && (
              <InfoContainer>
                <h4>{t('CompanyHistory:Approval.info')}</h4>
                <p>{props.request.additional_info}</p>
              </InfoContainer>
            )}
          </DialogContent>

          <ButtonGroup>
            <CancelButton
              type='button'
              onClick={props.handleClose}
              disabled={isSubmitting}
            >
              {t('CompanyHistory:Approval.cancel')}
            </CancelButton>
            <AcceptButton
              type='submit'
              disabled={isSubmitting}
            >
              {isSubmitting ?
                t('CompanyHistory:Common.processing') || 'Processing...'
              : t('CompanyHistory:Approval.accept')}
            </AcceptButton>
          </ButtonGroup>
        </DialogForm>
      </DialogContainer>
    </Backdrop>
  )
}

export default ApprovalDialog
